import { useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtEUR, fmtDate } from "@/lib/api";
import { Mail, ArrowRight, FileText } from "lucide-react";

export default function History() {
  const [email, setEmail] = useState("");
  const [data, setData] = useState(null);
  const [credits, setCredits] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    if (!email) return;
    setLoading(true);
    try {
      const [{ data: evs }, { data: cr }] = await Promise.all([
        api.get(`/evaluations/history/${encodeURIComponent(email)}`),
        api.get(`/credits/${encodeURIComponent(email)}`),
      ]);
      setData(evs); setCredits(cr);
    } finally { setLoading(false); }
  };

  return (
    <main data-testid="history-page" className="bg-[#F6F4EE] min-h-screen text-[#0D1F2D]">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10 py-14">
        <div className="mono text-[11px] uppercase tracking-[0.22em] text-[#52616B]">§ Istoric evaluări</div>
        <h1 className="font-display text-5xl lg:text-6xl font-bold tracking-tight mt-3">Evaluările tale.</h1>
        <p className="mt-4 text-[#52616B] max-w-xl">Introdu emailul pe care ai salvat evaluările pentru a le regăsi.</p>

        <div className="mt-10 flex max-w-xl gap-2 items-end">
          <div className="flex-1 border-b border-[#0D1F2D] flex items-center gap-2 pb-1">
            <Mail size={16} />
            <input
              data-testid="history-email"
              type="email" value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="numele.tau@email.ro"
              className="flex-1 bg-transparent focus:outline-none text-lg font-display py-2"
            />
          </div>
          <button data-testid="history-load" onClick={load} disabled={loading || !email} className="bg-[#0D1F2D] text-[#F6F4EE] px-6 h-11 rounded-sm font-medium hover:bg-[#0F6E5B] transition-colors">
            {loading ? "…" : "Afișează"}
          </button>
        </div>

        {credits && (
          <div className="mt-10 bg-white border border-[#DEDCCF] p-6 max-w-xl">
            <div className="mono text-[11px] uppercase tracking-[0.22em] text-[#52616B]">Credite rapoarte premium</div>
            <div className="font-display text-4xl font-bold mt-2 text-[#0F6E5B]">{credits.credits_remaining}</div>
            <div className="text-sm text-[#52616B] mt-1">rapoarte disponibile</div>
          </div>
        )}

        {data && (
          <div className="mt-10">
            {data.length === 0 ? (
              <div className="text-[#52616B]">Niciun istoric găsit pentru acest email. <Link to="/evaluare" className="underline hover:text-[#0F6E5B]">Fă prima evaluare →</Link></div>
            ) : (
              <div className="divide-y divide-[#DEDCCF] border-y border-[#DEDCCF] bg-white">
                {data.map((e) => (
                  <Link key={e.id} to={`/rezultat/${e.id}`} data-testid={`history-item-${e.id}`} className="grid grid-cols-12 gap-4 px-6 py-5 hover:bg-[#F6F4EE] transition-colors">
                    <div className="col-span-3 mono text-xs text-[#52616B] self-center">{fmtDate(e.created_at)}</div>
                    <div className="col-span-5 self-center">
                      <div className="font-display text-lg font-bold">{(e.input.property_type).charAt(0).toUpperCase() + e.input.property_type.slice(1)} · {e.factors.city_label}</div>
                      <div className="text-xs text-[#52616B] mt-1">{e.input.surface} m² · {e.input.neighborhood || "zonă —"}</div>
                    </div>
                    <div className="col-span-3 self-center text-right font-display text-xl font-bold text-[#0F6E5B]">{fmtEUR(e.estimated_value_eur)}</div>
                    <div className="col-span-1 self-center text-right text-[#52616B]"><ArrowRight size={16} className="inline" /></div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </main>
  );
}
